import React, {useCallback} from "react";
import {
    Create,
    TabbedForm,
    FormTab,
    TextInput,
    SelectInput,
    DateInput,
    Toolbar,
    useCreate,
    useRedirect,
    useNotify,
    SaveButton
} from 'react-admin';
import "../legal_entity/styles/main.css"
import required from "../helper/Required";
import SaveButtonAware from "../component/SaveButtonAware";

const LicenseCreate = props => {
    const Title = props => (
        <div className="title-wrapper">
            <span className="title-text">Додавання лтцензії</span>
        </div>
    );

    const LicenseCreateToolbar = props => {
        const [create, { loading, error }] = useCreate('licenses');
        const redirectTo = useRedirect();
        const notify = useNotify();
        const { basePath } = props;
        const handleSave = useCallback(
            (values, redirect) => {
                create(
                    { payload: {data: {...values}} },
                    {
                        onSuccess: ({data: newRecord}) => {
                            notify('Статья добавлена', 'info');
                            redirectTo(redirect, basePath, newRecord.id, newRecord);
                        },
                        onError: (error) => {
                            console.log(error);
                        }
                    }
                );
            },
            [create, notify, redirectTo, basePath]
        );

        if (error) {
            notify('Ошибка: Ліцензія такого типу вже існує', 'warning');
        }

        return <Toolbar {...props}><SaveButton {...props} disabled={loading} submitOnEnter={false} onSave={handleSave} /></Toolbar>;
    };

    return (
        <Create {...props} title={<Title {...props} />}>
            <TabbedForm validate={required.validateLicenseCreate} toolbar={<LicenseCreateToolbar {...props} />}>
                <FormTab contentClassName="legal-entities-tab-content" label={<span>Ліцензія <sup>*</sup></span>}>
                    <SelectInput formClassName="tab-content-item" label="Тип ліцензії" source="type" validate={required.validateRequired} choices={[
                        // { id: 'MSP', name: 'ліцензія на провадження господарської діяльності з медичної практики' },
                        // { id: 'PHARMACY', name: 'ліцензія на провадження господарської діяльності з роздрібної торгівлі лікарськими засобами' },
                        { id: 'PHARMACY_DRUGS', name: 'ліцензія на право провадження господарської діяльності з обігу наркотичних засобів, психотропних речовин і прекурсорів' }
                    ]} />
                    <TextInput formClassName="tab-content-item" label="Ким видана" source="issuedBy" validate={required.validateRequired} />
                    <DateInput formClassName="tab-content-item" label="Дата видачі ліцензії" source="issuedDate" validate={required.validateRequired} />
                    <DateInput formClassName="tab-content-item" label="Початок дії ліцензії" source="activeFromDate" validate={required.validateRequired} />
                    <TextInput formClassName="tab-content-item" label="Номер наказу" source="orderNo" validate={required.validateRequired} />
                    <DateInput formClassName="tab-content-item" label="Ліцензія діє до" source="expiryDate" validate={required.validateRequired} />
                    <TextInput formClassName="tab-content-item" label="Серія та номер ліцензії" source="licenseNumber" />
                    <TextInput formClassName="tab-content-item" label="Вид діяльності, що ліцензовано" source="whatLicensed" validate={required.validateRequired} />
                </FormTab>
            </TabbedForm>
        </Create>
    );
};

export default LicenseCreate;
